import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: ['defaultList'],
  data: function data() {
    return {
      SList: [{
        value: "ACCEPT",
        label: this.$t("lang.ConfigSetting.accept")
      }, {
        value: "REJECT",
        label: this.$t("lang.ConfigSetting.reject")
      }, {
        value: "DROP",
        label: this.$t("lang.ConfigSetting.drop")
      }],
      loading: true
    };
  },
  watch: {
    "defaultList": {
      immediate: true,
      handler: function handler(newVal) {
        if (this.defaultList.length > 0) {
          this.defaultList.forEach(function (item) {
            if (item.options.syn_flood === '1' || item.options.syn_flood) {
              item.options.syn_flood = true;
            } else {
              item.options.syn_flood = false;
            }

            if (item.options.drop_invalid === '1' || item.options.drop_invalid) {
              item.options.drop_invalid = true;
            } else {
              item.options.drop_invalid = false;
            }
          });
        }
      }
    }
  }
};